import { useCallback, useSyncExternalStore } from 'react';
import {
    COMPARE_LIMIT,
    addToCompare,
    getCompareList,
    isInCompare,
    removeFromCompare,
    subscribeCompare,
} from '../../utils/common/compare';

export const useCompare = () => {
    const list = useSyncExternalStore(
        subscribeCompare,
        getCompareList,
        () => [],
    );

    const toggle = useCallback((entry) => {
        if (isInCompare(entry)) {
            removeFromCompare(entry);
            return false;
        }
        return addToCompare(entry);
    }, []);

    return { list, count: list.length, toggle, limit: COMPARE_LIMIT };
};

export const useIsInCompare = (entry) => {
    const check = useCallback(
        () => (entry ? isInCompare(entry) : false),
        [entry?.id, entry?.type],
    );
    return useSyncExternalStore(subscribeCompare, check, () => false);
};
